var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-edit",
    d: "M21.321,5.01a3.673,3.673,0,0,0-2.606,1.075L7.062,17.737a1.842,1.842,0,0,0-.469.8L5.031,24a.79.79,0,0,0,.976.976l5.47-1.562h0a1.845,1.845,0,0,0,.8-.468L23.927,11.3A3.68,3.68,0,0,0,21.321,5.01Zm0,1.57a2.1,2.1,0,0,1,1.488.621h0a2.093,2.093,0,0,1,0,2.978L21.789,11.2,18.811,8.222,19.832,7.2A2.1,2.1,0,0,1,21.321,6.58ZM17.695,9.339l2.978,2.978-9.516,9.516a.267.267,0,0,1-.114.067l-4.1,1.172,1.172-4.1h0a.258.258,0,0,1,.067-.113Z",
    transform: "translate(-5.001 -5.01)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.cba4929aa5780ae1499f8824e711b30e.svg";
export { ForwardRef as ReactComponent };